import { useState } from "react";
import './accordion.css';

export default function Accordion(props) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleAccordion = () => {
        setIsOpen(!isOpen);
    };
    return(
        <div className="accordion">
            <button
            className={`btnAccordion ${isOpen ? 'active' : ''}`}
            onClick={toggleAccordion}>
                { props.title }
            </button>
            <div className={`accordionBody ${isOpen ? 'active' : ''}`}>
                {props.body && <p>{ props.body }</p> }
                {props.link && <a href={ props.download } download>{ props.link }</a>}
            </div>
        </div>
    )
}